import { Brick, Query, Order, Predicate, WorkflowObjectState, registerBrick, CloudObject } from 'olympe';
import { executeLambda, getLogger } from '@olympeio/core';
import BCP from '../../../common/section_bcp/DM_BCP.js';
import { BCP_WORKFLOW_STATES } from '../../../common/section_bcp/BcpWorkflowAuthorizations';
import { getApplicationContext } from '../../../common/utils/Context';

export default class BCPFetchWithPagination extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} user
     * @param {number} limit
     * @param {boolean} isAdmin
     * @param {*} filters
     * @param {*} getMaterials
     * @param {*} workflowContext
     * @param {function()} forwardEvent
     * @param {function(*)} setBCPData
     * @param {function(Map)} setWorkflows
    * @param {function(Map)} setBcpStatusData
     */
    async update($, [user, limit, isAdmin, filters, getMaterials], [forwardEvent, setBCPData, setWorkflows, setBcpStatusData]) {

        const logger = getLogger('BcpFetchWithPagination');
        // BCP request pagination parameters stored in the application context.
        const applicationContext = getApplicationContext($);
        // Initial row data sliced data from original row with 'limit' property value
        const [userName, email] = user.split(';');
        applicationContext.set("userName", userName)
        const alternativeEmail = applicationContext.get("alternativeEmail")
        applicationContext.set("email", email)
        const currentUser = email ?? userName;
        logger.info(" alternativeEmail, currentUser, userName in BCP fetch with pagination", alternativeEmail, currentUser, userName)
        const queryOffset = applicationContext.get('GetBCPRequest_queryOffset');
        const offset = applicationContext.get('GetBCPRequest_paginationOffset');
        const workflowMap = applicationContext.get('GetBCPRequest_workflowMap') ?? new Map();
        // const currentPageTags = applicationContext.get('GetBCPRequest_currentPageTags') ?? new Set();
        const seenTags = applicationContext.get('GetBCPRequest_seenTags') ?? new Set();
        logger.info(":::: seen Tags :::::", seenTags)
        const queriesOffsets = (queryOffset ?? '0;0;0').split(';').map(Number);
        const totalOffset = Number(offset) ?? 0;
        logger.info("queryOffset,offset, workflowMap, seenTags, queriesOffsets,totalOffset ",
            queryOffset, offset, workflowMap, seenTags, queriesOffsets, totalOffset)
        logger.info("value of currentUser , userName,alternativeEmail ", currentUser, userName, alternativeEmail)
        // bcpStatusmap
        const bcpStatusMap = applicationContext.get('GetBCPRequest_statusMap') ?? new Map();

        let query1BCPPred = Predicate.or(Predicate.contains(BCP.get(BCP.requestorProp), currentUser, false),
            Predicate.contains(BCP.get(BCP.requestorProp), userName, false),
            Predicate.contains(BCP.get(BCP.requestorProp), alternativeEmail, false));


        // query 2 fetches request for the BP criteria
        // adapt query/values/relations to proper state values using constants in BCPWorkflowAuthorizations.
        /* This to to make sure user with different email address like with domain nesexpresso and nestle ,
        / we would consider either email or userId*/
        let query2BCPPred = Predicate.or(Predicate.contains(BCP.get(BCP.businessPartnerProp), currentUser, false),
            Predicate.contains(BCP.get(BCP.businessPartnerProp), userName, false),
            Predicate.contains(BCP.get(BCP.businessPartnerProp), alternativeEmail, false));

        let query2StatePredicate = Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP);

        // query 3 fetches request for the PM criteria - BCP request will be avaiable for the PM in all the BCP stages
        // adapt query/values/relations to proper state values using constants in BCPWorkflowAuthorizations.
        let query3BCPPred = Predicate.or(Predicate.contains(BCP.get(BCP.procurementManagerProp), currentUser, false),
            Predicate.contains(BCP.get(BCP.procurementManagerProp), userName, false),
            Predicate.contains(BCP.get(BCP.procurementManagerProp), alternativeEmail, false));

        let query3StatePredicate = Predicate.or(Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM),
            Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE),
            Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1),
            Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2),
            Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION)
        );

        // query 4 fetches request for the QA factory 2 criteria
        // adapt query/values/relations to proper state values using constants in BCPWorkflowAuthorizations.
        let query4BCPPred = Predicate.or(Predicate.contains(BCP.get(BCP.technicalApplicationGroupProp), currentUser, false),
            Predicate.contains(BCP.get(BCP.technicalApplicationGroupProp), userName, false),
            Predicate.contains(BCP.get(BCP.technicalApplicationGroupProp), alternativeEmail, false));
        let query4StatePredicate = Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE);

        // query 5 fetches request for the QA factory 1 criteria
        // adapt query/values/relations to proper state values using constants in BCPWorkflowAuthorizations.
        // query 5 fetches request for the QA in factory person criteria - BCP request will be avaiable for the QA in factory person in QA1 or QA2 or Waiting on completion state.
        let query5BCPPred = Predicate.or(Predicate.contains(BCP.get(BCP.qaInFactoryProp), currentUser, false),
            Predicate.contains(BCP.get(BCP.qaInFactoryProp), userName, false),
            Predicate.contains(BCP.get(BCP.qaInFactoryProp), alternativeEmail, false));
        let query5StatePredicate = Predicate.or(Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1),
            Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2),
            Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION));

        //  // query 6 fetches request for the QA factory 2 criteria
        // // adapt query/values/relations to proper state values using constants in BCPWorkflowAuthorizations.
        let query6BCPPred = Predicate.or(Predicate.contains(BCP.get(BCP.qualityAssuranceProp), currentUser, false),
            Predicate.contains(BCP.get(BCP.qualityAssuranceProp), userName, false),
            Predicate.contains(BCP.get(BCP.qualityAssuranceProp), alternativeEmail, false));
        let query6StatePredicate = Predicate.or(Predicate.equals(WorkflowObjectState.stateProp,
            BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1),
            Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2));

        //Add Procurement Specialist stakeholder to view the bcp request 
        let query7BCPPred = Predicate.or(Predicate.contains(BCP.get(BCP.procurementSpecialistProp), currentUser, false),
            Predicate.contains(BCP.get(BCP.procurementSpecialistProp), userName, false),
            Predicate.contains(BCP.get(BCP.procurementSpecialistProp), alternativeEmail, false));

        let allBCPPreds, workflowPreds;

        //FILTER Query
        if (filters) {
            let filterKeys = Object.keys(filters);
            const idxOfWorkFlowStateFilter = filterKeys.indexOf('bCPStatus');
            filterKeys = idxOfWorkFlowStateFilter >= 0 ?
                filterKeys.filter((item, id) => id !== idxOfWorkFlowStateFilter) : filterKeys;
            filterKeys = filterKeys.filter(key => filters[key].values?.length > 0);


            //check all filters other than BCP state
            if (filterKeys.length > 0) {

                //Get list of Equals pred for each checked filter item
                const listOfPredsForFilterItems = filterKeys.map(key => {
                    const predKey = `${key}Prop`;
                    const values = filters[key].values;
                    return values.map(item => Predicate.equals(BCP[predKey], item.value));
                });

                const listOfORPreds = listOfPredsForFilterItems.length && listOfPredsForFilterItems.map(pred => Predicate.or(...pred));
                allBCPPreds = listOfORPreds.length && Predicate.and(...listOfORPreds);
            }

            //get Workflow state Predicates
            if (idxOfWorkFlowStateFilter >= 0) {
                const workFlowFilterValues = filters.bCPStatus.values;
                if (workFlowFilterValues.length > 0) {
                    const workFlowStatePred = workFlowFilterValues.map(item => Predicate.equals(WorkflowObjectState.stateProp,
                        item.value));
                    workflowPreds = Predicate.or(...workFlowStatePred);
                }
            }
        }

        let adminQuery = Query.instancesOf(BCP).sortBy(BCP.requestDateProp, Order.DESC).andReturn().limit(limit, totalOffset).follow(WorkflowObjectState.currentObjectRel.getInverse()).andReturn();


        if (allBCPPreds) {
            query1BCPPred = Predicate.and(query1BCPPred, allBCPPreds);
            query2BCPPred = Predicate.and(query2BCPPred, allBCPPreds);
            query3BCPPred = Predicate.and(query3BCPPred, allBCPPreds);
            query4BCPPred = Predicate.and(query4BCPPred, allBCPPreds);
            query5BCPPred = Predicate.and(query5BCPPred, allBCPPreds);
            query6BCPPred = Predicate.and(query6BCPPred, allBCPPreds);
            query7BCPPred = Predicate.and(query7BCPPred, allBCPPreds);

            adminQuery = adminQuery.back().filter(allBCPPreds);
        }
        let query1 = Query.instancesOf(BCP).filter(query1BCPPred).sortBy(BCP.requestDateProp, Order.DESC).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).andReturn().limit(limit, queriesOffsets[0]);
        let query7 = Query.instancesOf(BCP).filter(query7BCPPred).sortBy(BCP.requestDateProp, Order.DESC).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).andReturn().limit(limit, queriesOffsets[0]);

        if (!allBCPPreds && workflowPreds) {
            adminQuery = adminQuery.filter(workflowPreds).andReturn();
        }
        if (allBCPPreds && workflowPreds) {
            adminQuery = adminQuery.follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(workflowPreds).andReturn();
        }

        if (workflowPreds) {
            query1 = query1.filter(workflowPreds);
            query7 = query7.filter(workflowPreds);
            query2StatePredicate = Predicate.and(query2StatePredicate, workflowPreds);
            query3StatePredicate = Predicate.and(query3StatePredicate, workflowPreds);
        }

        const query2 = Query.instancesOf(BCP).filter(query2BCPPred).sortBy(BCP.requestDateProp, Order.DESC).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(query2StatePredicate).andReturn().limit(limit, queriesOffsets[1]);

        const query3 = Query.instancesOf(BCP).filter(query3BCPPred).sortBy(BCP.requestDateProp, Order.DESC).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(query3StatePredicate).andReturn().limit(limit, queriesOffsets[2]);
        const query4 = Query.instancesOf(BCP).filter(query4BCPPred).sortBy(BCP.requestDateProp, Order.DESC).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(query4StatePredicate).andReturn().limit(limit, queriesOffsets[2]);
        const query5 = Query.instancesOf(BCP).filter(query5BCPPred).sortBy(BCP.requestDateProp, Order.DESC).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(query5StatePredicate).andReturn().limit(limit, queriesOffsets[2]);
        const query6 = Query.instancesOf(BCP).filter(query6BCPPred).sortBy(BCP.requestDateProp, Order.DESC).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(query6StatePredicate).andReturn().limit(limit, queriesOffsets[2]);

        try {
            // new values to be updated for either/or admin, regular users BCP queries with pagination
            let newQueryOffset = queryOffset;
            // noinspection JSUnusedAssignment
            let newOffset = totalOffset;
            let newSeenTags = new Set();
            let newWorkflowEntries = [];
            let newEnteriesBcpStatus = [];
            let newBCPResult = [];
            if (isAdmin) {
                //  adminRes contain [[BCP1, Workflow1],[BCP2, Workflow2]]
                const adminRes = (await adminQuery.execute($)).toArray();
                // update new workflow entries
                newWorkflowEntries = adminRes.map(([bcp, workflow]) => ([bcp.getTag(), workflow]));

                // update offset for pagination :
                newOffset = totalOffset + adminRes.length;
                // update the new result
                newBCPResult = adminRes.map(([bcp, _]) => (bcp));
            }

            else {
                // result contain [BCP ,Workflows]
                const res1 = (await query1.execute($)).toArray();
                // get result & isolate request from workflow state
                const res2 = (await query2.execute($)).toArray();
                // get result & isolate request from workflow state
                const res3 = (await query3.execute($)).toArray();

                // get result & isolate request from workflow state
                const res4 = (await query4.execute($)).toArray();
                // get result & isolate request from workflow state
                const res5 = (await query5.execute($)).toArray();
                // get result & isolate request from workflow state
                const res6 = (await query6.execute($)).toArray();
                // get result & isolate request from workflow state
                const res7 = (await query7.execute($)).toArray();
                // logger.info("query 6", res6)

                // combine all 3 array while removing duplicates
                // init concat result with res1

                // get maximum size for concat results:
                // avoid edge case where we do not have enough results to fill up to "limit" length
                const maxSize = Math.min(limit, res1.length + res2.length + res3.length + res4.length + res5.length + res6.length + res7.length);
                let cursors = [0, 0, 0, 0, 0, 0, 0];
                while (newBCPResult.length < maxSize) {
                    const [req1, workflow1] = res1[cursors[0]] ?? [];
                    const [req2, workflow2] = res2[cursors[1]] ?? [];
                    const [req3, workflow3] = res3[cursors[2]] ?? [];
                    const [req4, workflow4] = res4[cursors[3]] ?? [];
                    const [req5, workflow5] = res5[cursors[4]] ?? [];
                    const [req6, workflow6] = res6[cursors[5]] ?? [];
                    const [req7, workflow7] = res7[cursors[6]] ?? [];
                    const requestsToMerge = [req1, req2, req3, req4, req5, req6, req7];
                    const workflowsToMerge = [workflow1, workflow2, workflow3, workflow4, workflow5, workflow6, workflow7];
                    const maxDate = Math.max(
                        req1 ? req1.get(BCP.requestDateProp).getTime() : -Infinity,
                        req2 ? req2.get(BCP.requestDateProp).getTime() : -Infinity,
                        req3 ? req3.get(BCP.requestDateProp).getTime() : -Infinity,
                        req4 ? req4.get(BCP.requestDateProp).getTime() : -Infinity,
                        req5 ? req5.get(BCP.requestDateProp).getTime() : -Infinity,
                        req6 ? req6.get(BCP.requestDateProp).getTime() : -Infinity,
                        req7 ? req7.get(BCP.requestDateProp).getTime() : -Infinity
                    );
                    // need to check if null!
                    console.log(":<<< requests To Merge>>>", requestsToMerge)
                    const requestIndex = requestsToMerge.findIndex(req => req && req.get(BCP.requestDateProp).getTime() === maxDate);

                    if (requestIndex !== -1) {
                        const nextRequest = requestsToMerge[requestIndex];
                        console.log(":: seenTags, nextRequest.tag ::", seenTags, nextRequest);
                        console.log(":: seenTags.has(nextRequest.tag) :::", seenTags.has(nextRequest.tag))
                        if (!seenTags.has(nextRequest.tag)) {
                            console.log(" This is a new request::::::::::", nextRequest.tag, seenTags)
                            const nextWorkflow = workflowsToMerge[requestIndex];
                            newWorkflowEntries.push([nextRequest.tag, nextWorkflow]);
                            seenTags.add(nextRequest.tag);
                            // currentPageTags.add(nextRequest.tag)
                            newBCPResult.push(nextRequest);
                        }
                        logger.info("new BCP Result", newBCPResult?.length);
                        // move cursor regardless (ignoring duplicate)
                        cursors[requestIndex]++;

                    } else {
                        // all arrays exhausted
                        break;
                    }
                }
                // Update how many bcp were fetched totally for pagination in draw:
                newOffset = totalOffset + newBCPResult.length;

                // Set the three distinctive values for individual queries offset to application context
                newQueryOffset = queriesOffsets.map((queryOffset, idx) => queryOffset + cursors[idx]).join(';');

                // register tags that have been already seen in request (in case they show up in a later query)
                newSeenTags = seenTags;

                // update offset for individual queries
                for (let i = 0; i < queriesOffsets.length; i++) {
                    queriesOffsets[i] += cursors[i];
                }

            }
            // set new values for queries offset / seen tags
            applicationContext.set('GetBCPRequest_paginationOffset', newOffset);
            applicationContext.set('GetBCPRequest_queryOffset', newQueryOffset);
            console.log("before setting the seentags, applicationContext ::::::::::", newSeenTags, applicationContext)
            applicationContext.set('GetBCPRequest_seenTags', newSeenTags);
            // applicationContext.set('GetBCPRequest_currentPageTags', currentPageTags);

            // set result output
            let newWorkflowMap = workflowMap;
            if (newBCPResult.length > 0) {
                // created new context for workflow that combine newly fetched workflow with old one.
                // and set the new workflow map in application context
                newWorkflowMap = new Map([...workflowMap, ...new Map(newWorkflowEntries)]);
                applicationContext.set('GetBCPRequest_workflowMap', newWorkflowMap);
            }

            const materials = newBCPResult.map((BCP) => {
                return {
                    materialId: BCP.getMaterialId(),
                    plantId: BCP.getPlantId(),
                    bcp: BCP.getTag()
                };
            });
            logger.info(":::::::::::materials::::::::;", materials)

            // New code start
            const chunkSize = 1000;
            let results=[];
            for (let i = 0; i < materials.length; i += chunkSize) {
                const temporaryMaterials = materials.slice(i, i + chunkSize);
                // New code ends
                const bodyResult = await executeLambda($, getMaterials, [temporaryMaterials], 2315292707);
                const temporaryResult = JSON.parse(bodyResult)['results'].flat();
                logger.info(":::::::::::temporaryResult::::::::", temporaryResult)
                results.push(temporaryResult);
                // do whatever
            }

            logger.info("::::::Out of Loop::::results::::::::", results.flat())
           
            newEnteriesBcpStatus = results.flat().map((value) => ([value.material + "-" + value.plant, value.bcpStatus]));
            let newStatusMap = bcpStatusMap;
            logger.info("::: newStatusMap :::", newStatusMap)
            logger.info("::: newEnteriesBcpStatus :::", newEnteriesBcpStatus)

            if (results.length > 0) {
                // created new context for workflow that combine newly fetched bcp status  with old one.
                // and set the new bcp status map in application context
                newStatusMap = new Map([...bcpStatusMap, ...newEnteriesBcpStatus]);
                logger.info(":: newStatusMap :::",newStatusMap)
                applicationContext.set('GetBCPRequest_statusMap', newStatusMap);
            }
            setWorkflows(newWorkflowMap);
            setBcpStatusData(newStatusMap);
            logger.info("Before pushing newBCPResult,newSeenTag", newBCPResult, newSeenTags);
            setBCPData(newBCPResult);

        } catch (e) {
            console.error(e);
        }

        forwardEvent();
    }
}

registerBrick('018c21a3eb554475849f', BCPFetchWithPagination);
